import { TableHeader } from "@/models/TableHeader";

export const redirectHeaders: TableHeader[] = [
  {
    text: "Old URL",
    value: "from"
  },
  {
    text: "New URL",
    value: "to"
  },
  {
    text: "Actions...",
    sortable: false,
    value: null,
    width: "320px"
  }
];
